(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  // 20240904 Albert: Show popup on stage skirt specials for other colors
  ///////////////////////////////////////////////////////////////////////

  // Determine if we are in a Special-Special case, and show popup
  function showPopup() {
    // Get selected length
    let selectLength = document.getElementById('select_o_2003803');
    let length = selectLength.options[selectLength.selectedIndex].text;

    // Get corresponding Height selector
    let heightSelectorId = length.substring(0, 2).trim();
    let heightSelectorValue = parseInt(heightSelectorId);
    heightSelectorValue++;
    heightSelectorId = heightSelectorValue.toString();
    if (heightSelectorId.length < 2) {
      heightSelectorId = '0' + heightSelectorId;
    }
    heightSelectorId = 'select_o_20038' + heightSelectorId;

    // Get selected height
    let selectHeight = document.getElementById(heightSelectorId);
    let height = selectHeight.options[selectHeight.selectedIndex].text;

    // Check if both options have 'special'
    length = length.toUpperCase();
    height = height.toUpperCase();
    let showMessage = false;
    if(length.includes('SPECIAL') && height.includes('SPECIAL')) {
      // We are in a Special case, show message
      showMessage = true;
    } 

    let message = document.getElementById('stage-skirt-special-message');
    if (showMessage) {
      message.classList.add('show');
      document.getElementById('modalMessage').modal('show');
    } else {
      message.classList.remove('show');
    }
  }

  // Attach event listener to all selects with class
  function attachEventListener() {
    //console.log('attaching event listener');
    
    let selects = document.getElementsByClassName('mw-option__control mw-option__control--type-select');
    for (let i = 0; i < selects.length; i++) {
      if (selects[i].id == 'select_o_113813') {
        //skip velcro selector
        continue;
      } 
      console.log(selects[i]);
      selects[i].addEventListener('change', showPopup);
    }

    //console.log('event listener attached');
  }

  // Attach event listener to selects when page loads
  window.onload = attachEventListener;

  } catch(e) { console.error(e); }
})();
})();
